import React from "react";
import Logo from "../Img/logo.png";
import FormGerenteCambista from "../_Components/FormGerenteCambista";
import {getUsuarioFromStorage} from "../Utils/usuarioHelper";
import qs from "qs";
import { Link } from 'react-router-dom';

export class CadastroCambista extends React.Component {
    constructor(props) {
super(props);
        this.queryString = qs.parse(this.props.location.search, {ignoreQueryPrefix: true})
    }

    render() {
        const tutorId = JSON.parse(localStorage.getItem("user"));
        const {id} = this.queryString

        return (
            <div>
                <div className="wrapper">
                    <div className="sidebar" data-image="/assets/img/sidebar-5.jpg">
                        <div className="sidebar-wrapper">
                            <div className="logo">
                                <img src={Logo} style={{width: "10em", height: "4em"}}/>
                            </div>

                            <ul className="nav">
                                <li>
                                    <Link className="nav-link" to="gerente-bilhetes">
                                        <i className="nc-icon nc-tag-content"></i>
                                        <p>Cartelas</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="caixa-gerente">
                                        <i className="nc-icon nc-money-coins"></i>
                                        <p>Caixa gerente</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="caixas-por-cambistas">
                                        <i className="nc-icon nc-money-coins"></i>
                                        <p>Caixas cambistas</p>
                                    </Link>
                                </li>
                                {/* <li>
                                    <Link className="nav-link" to="relatorio-por-cambistas">
                                        <i className="nc-icon nc-chart-pie-36"></i>
                                        <p>Relatorio de vendas</p>
                                    </Link>
                                </li> */}
                                <li className="nav-item active">
                                    <Link className="nav-link" to="gerente-gerencia-cambistas">
                                        <i className="nc-icon nc-bullet-list-67"></i>
                                        <p>Gerenciar cambistas</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="perfil-gerente">
                                        <i className="nc-icon nc-circle-09"></i>
                                        <p>Perfil</p>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-panel">
                        <nav className="navbar navbar-expand-lg " color-on-scroll="500">
                            <div className="container-fluid">
                                <Link className="navbar-brand" to="#">Cadastro de Cambistas</Link>
                                <button
                                    to=""
                                    className="navbar-toggler navbar-toggler-right"
                                    type="button"
                                    data-toggle="collapse"
                                    aria-controls="navigation-index"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-bar burger-lines"></span>
                                    <span className="navbar-toggler-bar burger-lines"></span>
                                    <span className="navbar-toggler-bar burger-lines"></span>
                                </button>
                                <div
                                    className="collapse navbar-collapse justify-content-end"
                                    id="navigation"
                                >
                                    <ul className="navbar-nav ml-auto">
                                        <li className="nav-item">
                                            <Link className="nav-link" to="/">
                                                <span className="no-icon">Sair</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        <div className="content">
                            <div className="container-fluid">

                                <div className="row">
                                    <div className="col-md-12 col-lg-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h4 className="card-title">Cadastro de Cambistas</h4>
                                            </div>
                                            <div className="card-body">
                                                <FormGerenteCambista redirect={"/gerente-gerencia-cambistas"} perfil="CAMBISTA" tutorId={tutorId} id={id} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer className="footer">
                            <div className="container-fluid">
                                <nav>
                                    <ul className="footer-menu">
                                        <li>
                                            <Link to="#">Empresa</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Regulamento</Link>
                                        </li>
                                        <li>
                                            <Link to="#">Outros projetos</Link>
                                        </li>
                                    </ul>
                                    <p className="copyright text-center">
                                        Proprietário ©
                                        <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                                    </p>
                                </nav>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        );
    }
}

export default CadastroCambista;
